import React from "react";

export const VitalsIcon: React.FC = () => {
  return (
    <svg
      width="39px"
      height="36px"
      viewBox="0 0 39 36"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Provider-Global-navigation-V2.3"
          transform="translate(-14.000000, -271.000000)"
        >
          <g
            id="Vitals-menu-Copy-46"
            transform="translate(14.000000, 271.000000)"
          >
            <g id="Vitals-icon" transform="translate(7.000000, 6.000000)">
              <g id="Rectangle-Copy-212">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill="#7CBA5B"
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M17.0708319,10.0125108 C17.2458338,10.4354319 17.3333334,10.8802215 17.3333334,11.346893 C17.3333334,11.8573149 17.2276047,12.3385627 17.0161442,12.7906507 C16.8046836,13.2427387 16.5093725,13.6255495 16.1302019,13.9390944 C15.8531157,14.1943054 15.1385357,14.8469065 13.9864404,15.8969174 C12.9072625,16.8813026 12.2473698,17.4828623 12.0067423,17.7016146 C11.9265331,17.7672403 11.8353877,17.8000526 11.7333033,17.8000526 C11.6312189,17.8000526 11.5400735,17.7672403 11.4598643,17.7016146 C11.102569,17.3807779 10.1655941,16.524011 8.64891174,15.1312883 C7.92702926,14.4750315 7.515052,14.1031582 7.41296761,14.0156573 C7.38380064,13.9864903 7.35098829,13.9573238 7.31452958,13.9281568 C6.94265072,13.6146119 6.65463122,13.2336241 6.45046244,12.7851819 C6.24629366,12.3367398 6.14056498,11.8609607 6.13327324,11.3578305 C6.1259815,10.8984508 6.21348109,10.4536612 6.39577465,10.0234484 C6.56348472,9.61511079 6.8041086,9.25417497 7.11765352,8.94063005 C7.73015987,8.31354021 8.46296898,8 9.31610282,8 C9.78277433,8 10.225741,8.10208286 10.6450162,8.30625164 C11.0642914,8.51042043 11.4270501,8.79843993 11.7333033,9.17031878 C12.0395565,8.79843993 12.4023152,8.51042043 12.8215904,8.30625164 C13.2408656,8.10208286 13.6838323,8 14.1505038,8 C15.0036376,8 15.7364467,8.3098944 16.3489531,8.92969249 C16.662498,9.24323741 16.9031219,9.60417324 17.0708319,10.0125108 Z M12.3458066,9.75000939 C12.19268,9.95417818 11.9885143,10.056261 11.7333033,10.056261 C11.4780923,10.056261 11.2739266,9.95417818 11.1208,9.75000939 C10.9020477,9.46563144 10.6340802,9.24323664 10.3168894,9.08281831 C9.99969866,8.92239998 9.66610645,8.84219202 9.31610282,8.84219202 C8.69630473,8.84219202 8.16036971,9.07187846 7.70828169,9.53125822 C7.47494594,9.76459397 7.29630093,10.0343844 7.17234132,10.3406376 C7.03379821,10.6614742 6.96817352,11.0005352 6.97546526,11.3578305 C6.97546526,11.7297094 7.0520274,12.0851765 7.20515399,12.4242425 C7.35828058,12.7633085 7.57702957,13.0495051 7.86140751,13.2828409 C7.875991,13.3047161 7.90515753,13.3302368 7.94890798,13.3594038 C7.95619973,13.3666955 7.96349136,13.377633 7.9707831,13.3922164 C8.10203446,13.5088843 8.44474121,13.8187787 8.99891362,14.3219089 L9.52391644,14.8031615 C10.5739273,15.7583798 11.3103822,16.42921 11.7333033,16.8156723 C12.0687234,16.5094191 12.6301792,15.9990048 13.4176873,15.2844141 C14.4020725,14.3729463 15.1202984,13.7166994 15.5723864,13.3156535 L15.5942615,13.2937784 C15.8713477,13.0677344 16.0900967,12.7870065 16.250515,12.4515864 C16.4109334,12.1015828 16.4911413,11.7333553 16.4911413,11.346893 C16.4911413,10.9895976 16.4255166,10.6505367 16.2942653,10.3297 C16.1703057,10.0234468 15.9916607,9.75365641 15.7583249,9.52032066 C15.3062369,9.06823264 14.7703019,8.84219202 14.1505038,8.84219202 C13.8005001,8.84219202 13.4669079,8.92057707 13.1497171,9.07734953 C12.8325264,9.23412199 12.5645589,9.4583397 12.3458066,9.75000939 Z"
                id="heart-o---anticon"
                stroke="#FFFFFF"
                strokeWidth="0.5"
                fill="#FFFFFF"
              ></path>
              <path
                d="M10.3598872,12.5910928 L10.0702447,13.1878066 L7.12853333,13.1878066 C6.83398147,13.1878066 6.5952,12.9490252 6.5952,12.6544733 C6.5952,12.3599214 6.83398147,12.12114 7.12853333,12.12114 L9.40231547,12.12114 L10.4434652,9.97619032 L11.5824081,12.762858 L12.6000612,10.6631303 L13.2484911,12.4914431 L13.5231691,12.1189619 L16.6387232,12.1441023 C16.9332655,12.1464791 17.1701124,12.3871795 17.1677357,12.6817218 C17.1653589,12.9762641 16.9246585,13.213111 16.6301162,13.2107343 L14.0586976,13.1899847 L12.9146784,14.7413489 L12.4474055,13.4238265 L11.4995541,15.3795321 L10.3598872,12.5910928 Z"
                id="Path-5"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
